import React from 'react';
import Sidebar from './sidebar';
import FooterStyle from './footer';
import { Link } from 'react-router-dom';
// import { RightOutlined  } from '@ant-design/icons';

export const CareerPage = () => {
  return (
    <div className='top-layout'>
      <div className='Navbar'>
        <Sidebar />
      </div>
    
      <div className='layout'>

        <div className='KS-logo'>
          <Link to="/" style={{ position:'absolute', cursor: 'pointer', zIndex: '100'}}>
            <img src={process.env.PUBLIC_URL + '/images/KS_logo.png'} alt="Logo" style={{ width: '4.5rem', marginTop:'0.3rem'}} />
          </Link>
        </div>

        <div className='backgroundImage'>
          <img src={process.env.PUBLIC_URL + '/images/careerpage.jpg'} alt="headImage" style={{ width: '100%', position:'relative', top:'8rem' }} />  
          <h1>CAREER</h1>
        </div>


        <div className='careerForm'>
          <div className='careerintro'>
            
            <div className='careertext'>
              <h2>Join our team</h2>
            <p>
             {/* <RightOutlined />  */}
                Are you someone who aspires to both learn and lead?
                We are constantly seeking to attract top talent from around the globe at Kombinasi Saudagar.
                At Kombinasi Saudagar, we firmly believe that our ongoing success hinges on:
            </p>
            <ul>
              <li style={{ listStyleType:'square'}}>Teamwork</li>
              <li style={{ listStyleType:'square'}}>Diversity</li>
              <li style={{ listStyleType:'square'}}>Continual opportunity for personal and professional growth</li>
            </ul>
            <br/>
            <p>
            We are committed to conducting our business with integrity and responsibility on the global stage.
            We consider Kombinasi Saudagar to be not only an excellent company but also an outstanding place to build your career.
            Thank you for considering Kombinasi Saudagar as your potential employer.
            We encourage you to:
            </p>
            <ul>
              <li style={{ listStyleType:'square'}}>Submit your resume/CV</li>
              <li style={{ listStyleType:'square'}}>Passport-sized photograph</li>
              <li style={{ listStyleType:'square'}}>Explore the vacancies we have available</li>
            </ul>
            <br />
            {/* <div>
              <img src={process.env.PUBLIC_URL + '/images/pexels-sora-shimazaki-5673502.jpg'} alt="headImage" style={{ width: '100%'}} />
            </div> */}
            </div>
            
            <div className='careerinfo'>
              {/* <div>
                <img src={process.env.PUBLIC_URL + '/images/pexels-cottonbro-5989932.jpg'} alt="headImage" style={{ width: '50%'}} />
              </div> */}
              <h3>Human Resource Department</h3>
              <p>Suite 1.10, Lot 9 & 10, 
                <br/> Sedco Industrial Estate,
                <br/> Kolombong, Off Jalan Lintas,
                <br/> P.O. Box 22477, 88784 Luyang,
                <br/> Kota Kinabalu, Sabah, Malaysia.
              </p>
              <h3>Telephone</h3>
              <p>088-435 661 / 662 / 663</p>
              <h3>Fax</h3>
              <p>088-439 376</p>
              <h3>Email</h3>
              <p>info@kombinasi-saudagar.com</p>
              <a href='./images/Job Application Form_KSSB.pdf' target="_blank" rel="noopener noreferrer" style={{ color:'red'}}>View Job Application Form</a>
            </div>
            
          </div>
        </div>


        <div className='footer'>
          <FooterStyle />
        </div>

      </div>


    </div>
  );
}

export default CareerPage;
